// File: frontend/src/components/common/LoadingSpinner.js


import React from 'react';

const LoadingSpinner = ({ size = 'medium', fullScreen = false }) => {
  const sizeClasses = {
    small: 'w-6 h-6',
    medium: 'w-12 h-12',
    large: 'w-16 h-16'
  };

  return (
    <div
      className={`flex items-center justify-center ${
        fullScreen ? 'fixed inset-0 bg-gray-800 bg-opacity-50 z-50' : ''
      }`}
    >
      <svg
        className={`${sizeClasses[size]} animate-spin text-indigo-600`}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 4.418 3.582 8 8 8v-4zm9-1.343A7.962 7.962 0 0120 12h4c0 4.418-3.582 8-8 8v-4zm-9-9.343A7.962 7.962 0 014 12h-4c0-4.418 3.582-8 8-8v4z"
        />
      </svg>
      {fullScreen && <p className="ml-4 text-white">Loading... (12:30 AM BST, 07/03/2025)</p>}
    </div>
  );
};

export default LoadingSpinner;